import * as React from "react";
import { forwardRef } from "react";
const SvgSignOutIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.57143 8H13M13 8L11.0714 5.5M13 8L11.0714 10.5M9.14286 3H6C4.89543 3 4 3.89543 4 5V11C4 12.1046 4.89543 13 6 13H9.14286", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSignOutIcon);
export default ForwardRef;
